import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const postSeriesProgram = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ORGANIZE.POST_SERIES_PROGRAM,
    data
  );
};

export default postSeriesProgram;
